import React, { FC, useContext } from 'react';
import { Headline } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import { UeElement, UeReference } from '@oneaudi/falcon-tools';
import { Alignment, HeadingOption, ModuleType, TextItem } from '../../types';
import { TextComponentContainer, TextComponentsContainer, TextRow } from './TextMode.style';
import RichText from './RichText';
import { Context } from '../Context';
import { EditorialCTA } from './EditorialCTA';
import { EditorialHeadline } from './EditorialHeadline';

export interface TextModeProps {
  components: TextItem[][];
  headingOption?: HeadingOption;
  textAlignment: Alignment;
  ctaComponentList: TextItem[];
}

export const TextMode: FC<TextModeProps> = ({
  components,
  headingOption,
  textAlignment,
  ctaComponentList,
}) => {
  const { layerManager } = useContext(Context);

  return (
    <>
      {headingOption && (
        <EditorialHeadline
          headingOption={headingOption}
          alignment={textAlignment}
          testid="text-headline-container"
        />
      )}
      <TextComponentsContainer data-testid="numbers-components-container">
        {components.map((row, rowIdx) => (
          <TextRow
            flexibleWidth={false}
            data-testid="numbers-components-row"
            // eslint-disable-next-line react/no-array-index-key
            key={`row-${rowIdx}`}
          >
            {row.map((x: TextItem, elementIndex) => (
              <TextComponentContainer
                data-testid="text-component"
                key={`ge-${x.title}`}
                delay={`${elementIndex * 0.3}s`}
                flexibleWidth={false}
                textAlignment={textAlignment}
              >
                <UeReference propertyPath={`moduleContent.components.${rowIdx * 3 + elementIndex}`}>
                  {x.title && (
                    <Headline
                      key={`ge-title-${x.title}`}
                      tag="div"
                      variant={{ type: 'headline', order: '3', weight: 'normal' }}
                      data-testid="text-component-title"
                      margin={[0, 0, 'var(--spacing-relative-md)', 0]}
                    >
                      <UeElement type="text" property="title" label="Title">
                        {renderTextWithFootnotesReferencesV2(x.title)}
                      </UeElement>
                    </Headline>
                  )}
                  {x.description && (
                    <RichText
                      text={x.description}
                      type="richtext"
                      property="description"
                      label="Copy"
                    />
                  )}
                  {x.cta && (
                    <EditorialCTA
                      mode={ModuleType.TEXT}
                      cta={x.cta}
                      layerManager={layerManager}
                      alignment={textAlignment}
                      ctaComponentList={ctaComponentList}
                    />
                  )}
                </UeReference>
              </TextComponentContainer>
            ))}
          </TextRow>
        ))}
      </TextComponentsContainer>
    </>
  );
};
